export default __webpack_public_path__ + "static/media/new_arrow_green_button.f42a8c32.svg";